import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AppService } from './providers/app.service';
import { MenuService } from './providers/menu.service';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HomeComponent } from './components/home/home.component';
import { TechComponent } from './components/tech/tech.component';
import { WorkoutComponent } from './components/workout/workout.component';
import { GymComponent } from './components/gym/gym.component';
import { BlogComponent } from './components/blog/blog.component';
import { ArticleComponent } from './components/article/article.component';
import { MomentModule } from 'angular2-moment';
import { environment } from '../environments/environment';
import { HomepageResolver } from './providers/homepage-resolver.service';
import { WorkoutResolver } from './providers/workout-resolver.service';
import { TechnologyResolver } from './providers/technology-resolver.service';
import { SingleArticleResolver } from './providers/single-article-resolver.service';
import { GymResolver } from './providers/gym-resolver.service';
import { BlogResolver } from './providers/blog-resolver.service';
import { SwiperModule } from 'angular2-useful-swiper';
import { WindowRef } from './providers/window-ref';
import { NavigationComponent } from './components/navigation/navigation.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './components/footer/footer.component';
import { HeadingTagsStripPipe } from './pipes/heading-tags-strip.pipes';
import { ClassJoinedSuccessComponent } from './components/class-joined-success/class-joined-success.component';

const appRoutes: Routes = [
  {
    path: ':language/home',
    component: HomeComponent,
    resolve: {
      homepageData: HomepageResolver
    },
    data: {
      title: 'Overhand - Home',
      defaultLanguage: 'en'
    }
  },
  {
    path: ':language/workout',
    component: WorkoutComponent,
    resolve: {
      workouts: WorkoutResolver,
    },
    data: { title: 'Overhand - Workout' }
  },
  {
    path: ':language/blog',
    component: BlogComponent,
    resolve: {
      articles: BlogResolver,
    },
    data: { title: 'Overhand - Blog' } },
  {
    path: ':language/technology',
    component: TechComponent,
    resolve: {
      technology: TechnologyResolver,
    },
    data: { title: 'Overhand - Technology' }
  },
  {
    path: ':language/gym',
    component: GymComponent,
    resolve: {
      gym: GymResolver
    },
    data: { title: 'Overhand - Gym' }
  },
  {path: 'welcome-to-overhand-fitness', component: ClassJoinedSuccessComponent, data: { title: 'Welcome to Overhand Fitness !'}},
  { path: ':language/not-found', component: NotFoundComponent, data: { title: 'Overhand - Not Found' } },
  {
    path: ':language/article/:id',
    component: ArticleComponent,
    resolve: {
      article: SingleArticleResolver,
    },
    data: { title: 'Overhand - Article' }
  },
  { path: '', redirectTo: '/en/home', pathMatch: 'full' },
  { path: 'en', redirectTo: '/en/home', pathMatch: 'full' },
  { path: 'zh', redirectTo: '/zh/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/en/not-found', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HomeComponent,
    TechComponent,
    WorkoutComponent,
    GymComponent,
    BlogComponent,
    ArticleComponent,
    NavigationComponent,
    FooterComponent,
    ClassJoinedSuccessComponent,
    HeadingTagsStripPipe,
  ],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: !environment.production }
    ),
    SwiperModule,
    BrowserModule,
    MomentModule,
    HttpModule,
    FormsModule,
    BrowserAnimationsModule
  ],
  providers: [
    AppService,
    MenuService,
    HomepageResolver,
    WorkoutResolver,
    SingleArticleResolver,
    BlogResolver,
    TechnologyResolver,
    GymResolver,
    WindowRef,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts